import clsx from 'clsx';
import TextLeftIcon from '../../assets/icons/text-left-icon.svg?react';
import React, { ReactNode, useState } from 'react';

interface TextAreaProps {
  otherClasses?: {
    input?: string;
    container?: string;
    icon?: string;
    label?: string;
  };
  value: string | number;
  errorMessage?: string;
  label?: string | ReactNode;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: any) => void;
  placeholder: string;
  name: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  otherClasses,
  errorMessage = '',
  value,
  name,
  onBlur,
  label,
  onChange,
  disabled = false,
  placeholder,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const inputContainer = clsx(
    otherClasses?.container,
    'flex flex-col gap-2.5 items-start relative w-fit',
  );
  const inputClasses = clsx(
    otherClasses?.input,
    'w-full h-150 px-14 resize-none global-transition rounded-10 placeholder:text-neutral-tones-text/50 text-neutral-tones-text ring -tracking-form-input py-15 text-base font-normal font-inter-variable  outline-none disabled:ring-neutral-tones-text/35 disabled:placeholder:text-neutral-tones-text/35 disabled:text-neutral-tones-text/35 disabled:cursor-not-allowed',

    errorMessage !== ''
      ? 'ring-brand-posh-pink ring-2'
      : 'ring-neutral-tones-text/50 focus:ring-2 focus:ring-brand-byzantine',
  );
  const labelClasses = clsx(
    otherClasses?.label,
    'text-form-label  font-bold -tracking-form-label font-inter-variable',
    disabled
      ? 'text-neutral-tones-text/35 cursor-not-allowed'
      : 'text-neutral-tones-text',
  );

  // Handle focus and blur events
  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e: any) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  return (
    <div className={inputContainer} data-testid="text-area">
      {label && (
        <label htmlFor={name} className={labelClasses}>
          {label}
        </label>
      )}
      <div className="relative w-full">
        <TextLeftIcon
          className={clsx(
            'absolute left-5',
            errorMessage
              ? `[&>path]:stroke-brand-posh-pink`
              : disabled || value === ''
                ? isFocused
                  ? `[&>path]:stroke-brand-byzantine`
                  : '[&>path]:stroke-neutral-tones-text/35'
                : isFocused
                  ? '[&>path]:stroke-brand-byzantine'
                  : '[&>path]:stroke-neutral-tones-text',
            label ? 'top-4' : 'top-15',
          )}
        />
        <textarea
          disabled={disabled}
          onBlur={handleBlur}
          onFocus={handleFocus}
          name={name}
          id={name}
          value={value}
          autoComplete="new-password"
          onChange={(e) => onChange(e)}
          className={inputClasses}
          placeholder={placeholder}
        />
      </div>
      {errorMessage !== '' && (
        <span className="font-inter-variable text-brand-posh-pink absolute -bottom-5 left-0 text-xs font-normal">
          {errorMessage}
        </span>
      )}
    </div>
  );
};

export default TextArea;
